<div class="bg-white rounded-lg border max-w-xl">

    <div class="px-5 py-2 flex items-center">
        <span class="cursor-grab w-full flex items-center"><i class="ri-draggable"></i> <span
                class="text-xs font-semibold">Document From</span></span>
        <span class="divider divider-horizontal"></span>
        <span class="flex gap-3">

            <button *ngIf="isPreview" class="btn btn-sm btn-circle bg-white text-zinc-600"
                (click)="isPreview = false"><i class="ri-pencil-fill"></i></button>
            <button *ngIf="!isPreview" class="btn btn-sm btn-circle bg-white text-zinc-600"
                (click)="isPreview = true"><i class="ri-close-line"></i></button>
            <button *ngIf="!isPreview" class="btn btn-sm btn-circle bg-white text-green-600"><i
                    class="ri-check-line"></i></button>
            <button class="btn btn-sm btn-circle bg-white text-red-600"><i class="ri-delete-bin-7-line"></i></button>

        </span>
    </div>
    <hr>
    @if (isPreview) {
    <!-- preview -->
    <div class="p-5">
        <div class="w-full bg-white flex items-center gap-5 h-[7rem]">

            <div class="w-[15rem] h-full ">
                <img class="h-full w-full object-cover rounded-md" src="assets/dummy_thumbnail.png" alt="">
            </div>
            <ul class="w-full capitalize">
                <li class="grid grid-cols-2">
                    <span class="uppercase text-sm text-zinc-500">Title :</span><span class="font-semibold">Video
                        Title</span>
                </li>
                <li class="grid grid-cols-2">
                    <span class="uppercase text-sm text-zinc-500">price :</span><span class="font-semibold">1200</span>
                </li>
                <li class="grid grid-cols-2">
                    <span class="uppercase text-sm text-zinc-500">No. of views :</span><span
                        class="font-semibold">30</span>
                </li>
                <li class="grid grid-cols-2">
                    <span class="uppercase text-sm text-zinc-500">Reel :</span><span class="font-semibold">yes</span>
                </li>
            </ul>
        </div>
    </div>
    <!-- preview -->
    }@else {
    <!-- form -->
    <div class="p-5">
        <form action="">
            <div class="grid grid-cols-2 gap-5">

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Select Exam</span>
                        </div>
                        <select class="select select-sm select-bordered w-full">
                            <option disabled selected>Who shot first?</option>
                            <option>Han Solo</option>
                            <option>Greedo</option>
                        </select>
                    </label>
                </div>

                <div class="col-span-2">
                    <label class="label-text text-sm font-semibold">Analytics</label>

                    <div class="mt-5 flex items-start gap-5">
                        <span class="flex items-center gap-2">
                            <input type="radio" name="radio-1" class="radio radio-sm" id="immediate" />
                            <label for="immediate" class="text-sm ">Immediately</label>
                        </span>
                        <div class="flex flex-col gap-2">
                            <span class="flex items-center gap-2">
                                <input type="radio" name="radio-1" class="radio radio-sm" id="Schedule" />
                                <label for="Schedule" class="text-sm ">Schedule</label>
                            </span>
                            <span class="flex items-center gap-2">
                                <input type="date" class="input input-sm input-bordered">
                                <span>-</span>
                                <input type="date" class="input input-sm input-bordered">

                            </span>
                        </div>
                    </div>

                    <table class="mt-3 w-full rounded-lg border bg-zinc-100 border-zinc-200 overflow-hidden">
                        <tbody>
                            <tr>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox"
                                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                                        <label for="lock" class="text-sm font-semibold">Performance</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="lock" class="text-sm">Lock</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="show" class="text-sm"> Show</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox"
                                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                                        <label for="lock" class="text-sm font-semibold">Theory Explanation</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="lock" class="text-sm">Lock</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="show" class="text-sm"> Show</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox"
                                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                                        <label for="lock" class="text-sm font-semibold">Video Explanation</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="lock" class="text-sm">Lock</label>
                                    </div>
                                </td>
                                <td class="border px-2 py-3">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" class="checkbox checkbox-sm" />
                                        <label for="show" class="text-sm"> Show</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        
                    </table>


                </div>


                <div class="col-span-1">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">No of Attempt's</span>
                        </div>
                        <label class="input input-sm input-bordered flex items-center gap-2">
                            <!-- <i class="ri-eye-line"></i> -->
                            <input type="text" class="grow" placeholder="Daisy" />
                        </label>
                    </label>
                </div>

                <div class="col-span-1">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Price</span>
                        </div>
                        <label class="input input-sm input-bordered flex items-center gap-2">
                            ₹
                            <input type="text" class="grow" placeholder="Daisy" />
                        </label>
                    </label>
                </div>


                <div class="col-span-2 ">
                    <div class="flex items-center justify-between">
                        <label for="">Select Certificate</label>
                        <input type="checkbox" id="benifits"
                        class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    <select class="select select-sm select-bordered w-full mt-3">
                        <option disabled selected>Who shot first?</option>
                        <option>Han Solo</option>
                        <option>Greedo</option>
                    </select>
                </div>

                <div class="col-span-2 ">
                    <div class="flex items-center justify-between">
                        <label for="">Activity Per-Requisite</label>
                        <input type="checkbox" id="benifits"
                        class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    <button class="btn btn-sm mt-3">Activity to be Considered</button>
                </div>

            </div>
        </form>
    </div>
    <!-- form -->
    }

</div>